<template>
  <div class="card-body">
    <DeleteDistributionModal
      v-if="showDeleteModal"
      :distributionId="distribution.id"
      @closeModal="showDeleteModal = false"
    />
    <div class="row">
      <div class="col-12">
        <h6><strong>Nome: </strong> {{ distribution.name }}</h6>
      </div>
      <div class="col-12 col-md-8">
        <p><strong>Número: </strong> {{ distribution.id }}</p>
        <p><strong>Canal: </strong> {{ distribution.channel }}</p>
        <p>
          <strong>Agendamento: </strong>
          {{ dateTimeSqlToDateTimeBR(distribution.scheduleAt) }}
        </p>
        <p>
          <strong>Lembrete: </strong>
          <span v-if="distribution.remiderAt">{{
            dateTimeSqlToDateTimeBR(distribution.remiderAt)
          }}</span>
          <span v-else>Reenvio não programado</span>
        </p>
        <p>
          <strong>Validade: </strong>
          {{ dateTimeSqlToDateTimeBR(distribution.validityAt) }}
        </p>
        <p>
          <strong>Enviado: </strong>
          <span v-html="isSendTranslate(distribution.isSend)"> </span>
          <span v-if="Number(distribution.isSend) === 0">
            <span
              class="badge bg-yellow text-dark ms-1 cursor-pointer"
              @click="sendDistributionNow()"
              >Enviar Agora</span
            >
            <span
              class="badge bg-danger text-dark ms-1 cursor-pointer"
              @click="deleteDistribution()"
              >Excluir Distribuição</span
            >
          </span>
        </p>
        <p>
          <strong>Criado por: </strong>
          {{
            createdUpdatedUser(distribution.createdBy, distribution.createdAt)
          }}
        </p>
        <p v-if="distribution.updatedBy">
          <strong>Atualizado por: </strong>
          {{
            createdUpdatedUser(distribution.updatedBy, distribution.updatedAt)
          }}
        </p>
      </div>
      <div class="col-12 col-md-4">
        <ChartDistribution :surveys="distribution.statusAnswered" />
      </div>
    </div>
  </div>
</template>

<script>
import ChartDistribution from '@/components/distributions/ChartDistribution.vue'
import DeleteDistributionModal from '@/components/distributions/DeleteDistributionModal.vue'
import { isSendTranslate, createdUpdatedUser } from '@/utils/strings'
import { dateTimeSqlToDateTimeBR } from '@/utils/date'

export default {
  name: 'DetailsDistribution',

  props: {
    distribution: {
      type: Object,
      required: true,
    },
  },

  components: {
    ChartDistribution,
    DeleteDistributionModal,
  },

  data() {
    return {
      isLoadingData: true,
      dateTimeSqlToDateTimeBR,
      isSendTranslate,
      createdUpdatedUser,
      showDeleteModal: false,
    }
  },

  methods: {
    async sendDistributionNow() {
      try {
        const response = await this.$store.dispatch(
          'sendDistribution',
          this.distribution.id,
        )
        this.$root.$refs.notification.success(response.message)
        this.$emit('getAllResorces')
      } catch (error) {
        if (error && error.message) {
          this.$root.$refs.notification.warning(error.message)
        } else {
          this.$root.$refs.notification.error(
            'Não foi possível se conectar ao servidor.',
          )
        }
        this.$emit('closeModal', false)
      }
    },

    async deleteDistribution() {
      this.showDeleteModal = true
    },

    closeModal(redirect) {
      this.showDeleteModal = false
      if (redirect) {
        this.$router.push({ name: 'DistributionsList' })
      }
    },
  },
}
</script>
